import { extractHttpErrorMessage } from './http-error-message';

/** True when the message indicates OpenAI billing/quota exhaustion. */
export function isOpenAiQuotaExhaustedMessage(detail: string): boolean {
  const blob = String(detail || '').toLowerCase();
  return (
    blob.includes('insufficient_quota') ||
    blob.includes('credit_balance_exhausted') ||
    blob.includes('billing_hard_limit') ||
    blob.includes('credit/quota exhausted') ||
    (blob.includes('openai') && blob.includes('quota') && blob.includes('exhaust'))
  );
}

/** User-visible message from API / HttpClient errors (including timeouts). */
export function extractApiErrorMessage(err: unknown, fallback: string): string {
  const msg = extractHttpErrorMessage(err).trim();
  if (!msg || msg === 'Request failed') {
    return fallback;
  }
  return msg;
}

/** After an AI step fails, ask whether to continue the chat flow anyway. */
export function confirmContinueAfterAiError(title: string, detail: string): boolean {
  const t = String(title || 'Error').trim();
  const d = String(detail || '').trim();
  if (isOpenAiQuotaExhaustedMessage(d)) {
    return window.confirm(
      `${t}\n\n${d}\n\nThis is an OpenAI billing/quota failure — escalate to whoever manages the API key.\n\nContinue the workflow anyway (without AI)?`,
    );
  }
  return window.confirm(`${t}\n\n${d}\n\nContinue anyway?`);
}